export default __webpack_public_path__ + "static/media/krilnekapije3.812dac58.png";